import { useNavigate } from "react-router-dom";
import { Box, Tab, Tabs } from "@mui/material";
import RevenueList from "../../features/manageRevenue/revenueList";
import React from "react";
import ServiceFeeList from "../../features/manageRevenue/serviceFeeList";
import TaxList from "../../features/manageRevenue/taxList";
import ServiceProviderEarnings from "../../features/manageRevenue/serviceEarnings";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const ManageRevenue = () => {

  const navigate = useNavigate();
  const [valueTabs, setValueTabs] = React.useState(0);
  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };

  return (
    <>
      <div className="main_title">
        <h1>Revenue Management</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> - Revenue Management
        </p>
      </div>

      <div className="stats_boxes gap_m">
        <div className="cards">
          <figure>
            <img src="/static/images/money_icon.svg" alt="" />
          </figure>
          <h2>$2,500.00</h2>
          <p>Total Payment Recieved</p>
        </div>
        <div className="cards">
          <figure>
            <img src="/static/images/money_icon.svg" alt="" />
          </figure>
          <h2>$1,500.00</h2>
          <p>Total Payout</p>
        </div>
        <div className="cards">
          <figure>
            <img src="/static/images/money_icon.svg" alt="" />
          </figure>
          <h2>$1,000.00</h2>
          <p>Total Earnings</p>
        </div>
      </div>
      <div className="table_header mt_20">
        <div className="left_s">
          <Box className="custom_tabs1" sx={{ width: "100%" }}>
            <Tabs
              value={valueTabs}
              onChange={handleChangeTabs}
              aria-label="basic tabs example"
              className="custom_tabs_links"
            >
              <Tab label="Payments Received" {...a11yProps(0)} />
              <Tab label="Service Providers Earnings" {...a11yProps(1)} />
              <Tab label="Service Fee" {...a11yProps(2)} />
              <Tab label="Taxes" {...a11yProps(3)} />
            </Tabs>
          </Box>
        </div>
      </div>
      <div className="cards">
        <CustomTabPanel value={valueTabs} index={0}>
          <RevenueList />
        </CustomTabPanel>
        <CustomTabPanel value={valueTabs} index={1}>
            <ServiceProviderEarnings/>
        </CustomTabPanel>
        <CustomTabPanel value={valueTabs} index={2}>
          <ServiceFeeList />
        </CustomTabPanel>
        <CustomTabPanel value={valueTabs} index={3}>
          <TaxList />
        </CustomTabPanel>
      </div>
    </>
  );
};

export default ManageRevenue;
